import type { ICellRendererParams } from 'ag-grid-community'
import { AWSImage } from '@skop-app/lib-front'

type RowWithPictureAndName = {
  pictures?: string
  name?: unknown
}

export function ProductNameCellRenderer(
  params: ICellRendererParams<RowWithPictureAndName, unknown>,
) {
  const resolvedData = params.data ?? params.node.allLeafChildren?.[0]?.data
  const picture = resolvedData?.pictures || 'default.png'
  const label =
    params.node?.group && typeof resolvedData?.name === 'string'
      ? resolvedData.name
      : typeof params.value === 'string'
        ? params.value
        : ''
  return (
    <div className="flex items-center gap-2">
      <div className="h-10 w-10 overflow-hidden rounded-md border border-neutral-200">
        <AWSImage
          src={picture}
          alt={label}
          imgSize={36}
        />
      </div>
      <div>{label}</div>
    </div>
  )
}

